<div class="page__content">
    <div class="content__inner">
        <form [formGroup]="myForm" (submit)="onSubmit(myForm.value)" novalidate>
            <div class="card card_no_border">
                <button class="navbar-toggler" type="button" (click)="toggleSidebar()">
                    <span>{{ 'BOARD.MENU' | translate }}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-list" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                        </svg>
                    </span>
                </button>
                <!-- Velo para cerrar el drawer al pulsar fuera -->
                <div class="em-scrim" *ngIf="sidebarOpen" (click)="sidebarOpen = false"></div>
                <div id="container">
                    <div class="menuLateral em-sidebar" [class.is-open]="sidebarOpen" id="navbarSupportedContent"
                        aria-controls="navbarSupportedContent">
                        <div class="d-flex flex-wrap">
                            <div class="iconName rounded-circle" style="width: 60px; height: 60px;">
                                <p>{{getFirstLetter(this.currentUser.nombre)}}{{getFirstLetter(this.currentUser.apellido1)}}
                                </p>
                            </div>
                            <div *ngFor="let menu of menuListado" class="datos-personales">
                                <div *ngIf="menu.action == 20" class="col-sm-12 align-self-center">
                                    <h6>{{ this.currentUser.nombre }} {{this.currentUser.apellido1}}</h6>
                                    <p (click)="menu.action != null ? setSelectedOption(menu) : redirectUrl(menu)">
                                        {{ 'BOARD.EDIT_PROFILE' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <!--<pre>{{ menuListado | json }}</pre>-->
                        <mat-radio-group class="example-radio-group" formControlName="opcionesmenu">
                            <div *ngIf="currentUser !== undefined  && currentUser !== null && (currentUser.rol | json)">

                                <div *ngFor="let menu of menuListado">
                                    <div *ngIf="(menu.rol == null) && menu.action != 20">
                                        <div *ngIf="menu.listadoHijos &&  menu.listadoHijos.length == 0">
                                            <mat-radio-button class="radio-button" [value]="menu.nombre"
                                                (click)="menu.action != null ? setSelectedOption(menu) : redirectUrl(menu)"
                                                disableRipple="true">
                                                {{ menu.nombre }}
                                            </mat-radio-button>
                                        </div>
                                    </div>
                                </div>

                                <div *ngFor="let menu of menuListado">
                                    <div *ngFor="let rol of currentUser.rol">
                                        <div *ngIf="( menu.rol != null && rol == menu.rol['id']) && menu.action != 20">
                                            <div *ngIf="menu.listadoHijos &&  menu.listadoHijos.length == 0">
                                                <mat-radio-button class="radio-button" [value]="menu.nombre"
                                                    (click)="menu.action != null ? setSelectedOption(menu) : redirectUrl(menu)"
                                                    [checked]="menu.action==selectedOption.action" disableRipple="true">
                                                    <img src="{{ API_URL }}{{ menu.icono }}" /> {{ menu.nombre }}
                                                </mat-radio-button>
                                            </div>
                                            <div *ngIf="menu.listadoHijos.length != 0 && menu.action == 10">
                                                <div id="submenu">
                                                    <div (click)="changeCollapse(menu)">
                                                        <ng-container [ngSwitch]="menu.action">
                                                            <div *ngSwitchDefault>
                                                                <mat-radio-button [attr.href]="'#desplegable' + menu.id"
                                                                    [id]="menu.id" class="radio-button radio-title"
                                                                    [value]="menu.nombre" data-parent="#submenu"
                                                                    disableRipple="true"
                                                                    *ngIf="( menu.rol != null && rol == menu.rol['id']) && menu.action != 20">
                                                                    {{ menu.nombre
                                                                    }}



                                                                </mat-radio-button>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                    <ng-container *ngFor="let submenu of menu.listadoHijos">
                                                        <ul class="collapse show" [attr.id]="'desplegable' + menu.id"
                                                            *ngIf="submenu.nombre">
                                                            <mat-radio-button disableRipple="true"
                                                                (click)="submenu.action != null ? setSelectedOption(submenu) : redirectUrl(submenu)"
                                                                [value]="submenu.nombre"
                                                                [checked]="submenu.action==selectedOption.action"
                                                                style="font-weight: 500;"
                                                                *ngIf="showMenu(submenu, currentUser)">
                                                                <ng-container [ngSwitch]="submenu.action">
                                                                    <span *ngSwitchDefault>{{ submenu.nombre
                                                                        }}<!--<sup *ngIf="submenu.action == 33">2</sup>-->
                                                                    </span>
                                                                </ng-container>
                                                            </mat-radio-button>
                                                        </ul>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="currentUser === undefined  || currentUser === null">
                                <div *ngFor="let menu of menuListado">
                                    <div *ngIf="null == menu.rol && menu.action != 20">
                                        <div *ngIf="menu.listadoHijos.length == 0">
                                            <mat-radio-button class="radio-button" disableRipple="true"
                                                [value]="menu.nombre"
                                                (click)="menu.action != null ? setSelectedOption(menu) : redirectUrl(menu)">
                                                <img src="{{ API_URL }}{{ menu.icono }}" /> {{ menu.nombre }}
                                            </mat-radio-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>

                    <div class="center">

                        <ng-container [ngSwitch]="selectedOption.action">
                            <div *ngSwitchDefault>
                                <h1 class="marginBot075">{{ 'BOARD.WELCOME_TITLE' | translate }}</h1>
                                <p style="font-family: 'Lato'">
                                    {{ 'BOARD.WELCOME_P1' | translate }}
                                </p>
                                <p style="font-family: 'Lato'">
                                    {{ 'BOARD.WELCOME_P2' | translate }}
                                </p>
                            </div>

                            <div *ngSwitchCase="4">
                                <h1>{{ selectedOption.nombre }}</h1>
                            </div>

                            <div *ngSwitchCase="17">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-listado-procedimientos></app-listado-procedimientos>
                            </div>

                            <div *ngSwitchCase="18">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-listado-tramites-emvs></app-listado-tramites-emvs>
                            </div>

                            <div *ngSwitchCase="20">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-profile *appReloadDirective="reloadComponent"></app-profile>
                            </div>
                            <div *ngSwitchCase="35">
                                <h1 id="tituloProcedimientoDinamico">{{ selectedOption.nombre }}</h1>
                                <app-listado-procedimientos-dinamicos></app-listado-procedimientos-dinamicos>
                            </div>

                            <div *ngSwitchCase="40">
                                <h1 id="tituloProcedimientoDinamico">{{ selectedOption.nombre }}</h1>
                                <app-cuadro-de-mandos></app-cuadro-de-mandos>
                            </div>
                            <div *ngSwitchCase="41">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-listado-notificaciones-emvs></app-listado-notificaciones-emvs>
                            </div>
                            <div *ngSwitchCase="42">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-listado-errores-emvs></app-listado-errores-emvs>
                            </div>
                            <div *ngSwitchCase="50">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-gestion-usuarios></app-gestion-usuarios>
                            </div>
                            <div *ngSwitchCase="51">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-gestion-remesas></app-gestion-remesas>
                            </div>
                            <div *ngSwitchCase="52">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-gestion-listados></app-gestion-listados>
                            </div>
                            <div *ngSwitchCase="53">
                                <h1>{{ selectedOption.nombre }}</h1>
                                <app-gestion-plantillas></app-gestion-plantillas>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>